"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSEPHSSelectPaymentComponent = void 0;
const operators_1 = require("rxjs/operators");
const core_1 = require("@angular/core");
const expresspay_services_1 = require("../../../shared/services/expresspay.services");
const helper_service_1 = require("../../../../mma/shared/services/helper.service");
const index_1 = require("../../../../mma/shared/index");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const _ = require("underscore");
class CSEPHSSelectPaymentComponent {
    constructor(expressPayService, helperService, modalService, genericContentService) {
        this.expressPayService = expressPayService;
        this.helperService = helperService;
        this.modalService = modalService;
        this.genericContentService = genericContentService;
        this.classes = 'col-12';
        this.next = new core_1.EventEmitter();
        this.amtToPay = new core_1.EventEmitter();
        this.accNo = new core_1.EventEmitter();
        this.scrollTop();
    }
    ngOnInit() {
        this.loader = true;
        this.getFiberBillingDetails();
        this.getBillingAddress();
        this.isAuthenticated();
    }
    getFiberBillingDetails() {
        this.loader = true;
        this.expressPayService.getFiberBillingDetails()
            .subscribe((fiberBillingSummary) => {
            this.fiberBillingDetails = fiberBillingSummary;
            if (this.fiberBillingDetails.billAmountTotalPastDue > 0) {
                this.paymentExtensionEligiblity();
            }
            if (this.fiberBillingDetails.totalAmountDue > 0) {
                this.myBillAmount = 'PAY-MY-BILL';
            }
            else {
                this.myBillAmount = 'PAY-CUSTOM-BILL';
            }
            this.accNo.emit(this.fiberBillingDetails.accountId);
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    getBillingAddress() {
        this.loader = true;
        this.expressPayService.getFiberBillingAddress().subscribe((res) => {
            this.personalInfo = res;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    nextSection(type, fullPlanCost, differentAmt, pastDueAmount) {
        differentAmt = this.trimSpecialCharFromAmt(differentAmt);
        differentAmt = parseFloat(differentAmt);
        if (type === 'PAY-MY-BILL') {
            const paymentDetails = {
                'amountToPay': fullPlanCost,
                'payInFull': true,
                'payPastDueBalance': false,
            };
            this.amtToPay.emit(paymentDetails);
        }
        else if (type === 'PAY-PAST-DUE') {
            const paymentDetails = {
                'amountToPay': pastDueAmount,
                'payInFull': false,
                'payPastDueBalance': true,
            };
            this.amtToPay.emit(paymentDetails);
        }
        else {
            const paymentDetails = {
                'amountToPay': differentAmt,
                'payInFull': false,
                'payPastDueBalance': false,
            };
            this.amtToPay.emit(paymentDetails);
        }
        this.next.emit(true);
    }
    paymentExtensionEligiblity() {
        this.loader = true;
        this.expressPayService.getHSPaymentExtensionEligiblity()
            .subscribe((res) => {
            if (res) {
                this.loader = false;
                this.eligiblityDetails = res;
                if (res.eligibility) {
                    this.hidePaymentExtensionSection = false;
                }
            }
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
            this.hidePaymentExtensionSection = true;
        });
    }
    extendPayment() {
        this.loader = true;
        this.expressPayService.getHSExtendPaymentDate().pipe(operators_1.finalize(() => this.genericContentService.getGenericContent('genericPaymentExtensionSuccess').subscribe((res) => {
            this.paymentArrSuccessText = res.contentText;
            this.loader = false;
            if (this.error !== undefined) {
                this.paymentArrSuccessText = null;
            }
            else {
                this.paymentArrSuccessText = this.paymentArrSuccessText.toString().replace('EXTENDED_DATE', this.extendedDate.billDueDate);
                this.fiberBillingDetails.paymentArrangementDueDate = this.extendedDate.billDueDate;
            }
            this.modelRef.close();
        }, (err) => {
            this.error = err;
            this.loader = false;
        })))
            .subscribe((res) => {
            this.extendedDate = res;
            this.modelRef.close();
        }, (err) => {
            this.error = err;
            this.loader = false;
            this.scrollTop();
            this.modelRef.close();
        });
    }
    openPaymentArrModal() {
        event.preventDefault();
        this.modelRef = this.modalService.open(this.paymentArrPopup, { windowClass: 'dark-modal' });
    }
    scrollTop() {
        window.scrollTo(0, 200);
    }
    inputOnlyNumberAndPeriod(event) {
        return (event.charCode === 8 || event.charCode === 0) ? null : ((event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46);
    }
    selectedFiberPayBillMethod() {
        this.myBillAmount = 'PAY-MY-BILL';
    }
    onKey(event) {
        this.differentAmount = event.target.value;
    }
    convert(event) {
        event = this.trimSpecialCharFromAmt(event);
        this.differentAmount = parseFloat(event);
    }
    trimSpecialCharFromAmt(event) {
        if (event && event.includes(',')) {
            event = event.replaceAll(',', '');
        }
        return event;
    }
    isAuthenticated() {
        this.loader = true;
        this.expressPayService.loginAuthentication().subscribe((data) => {
            if (_.isEmpty(data)) {
                this.hideSection = true;
                this.helperService.onNavigate('/my_account/personal/express-pay/');
            }
            this.loader = false;
        }, (err) => {
            this.loader = false;
        });
    }
}
exports.CSEPHSSelectPaymentComponent = CSEPHSSelectPaymentComponent;
//# sourceMappingURL=selectpayment.component.js.map